import { memo } from 'react';
import { Pencil } from 'lucide-react';
import { Button } from '@components/ui/button';
import type { HomeFABProps } from '../types';

/**
 * Floating Action Button for creating questions
 *
 * Best practices applied:
 * - Wrapped with memo() to prevent unnecessary re-renders
 * - Named function for better React DevTools debugging
 * - Animate wrapper div instead of SVG for hardware acceleration
 */
export const HomeFAB = memo(function HomeFAB({ onClick }: HomeFABProps) {
  return (
    <div className="fixed bottom-[calc(var(--bottom-nav-offset)_+_var(--bottom-nav-height)_+_16px)] app-fixed pointer-events-none z-20">
      <Button
        onClick={onClick}
        className="w-[50px] h-[50px] float-right mr-[30px] pointer-events-auto bg-mb-teal text-mb-ink hover:bg-mb-teal-dark rounded-full shadow-float p-0 flex items-center justify-center"
        aria-label="Create a post"
      >
        {/* Wrap icon in div for potential animation - SVG animations aren't hardware accelerated */}
        <div>
          <Pencil className="w-[22px] h-[22px] text-mb-ink shadow-glow-teal" />
        </div>
      </Button>
    </div>
  );
});
